// src/components/Freelancer.js

import React, { useState } from 'react';
import './Freelancer.css';

const Freelancer = () => {
  const [currentLanguage] = useState('english');

  const translations = {
    english: {
      pageTitle: "Freelancer Network",
      pageSubtitle: "Join India's Largest Community of Financial Freelancers",
      
      // Hero Section
      heroTitle: "Earn Up to ₹2 Lakhs/Month as a Financial Freelancer",
      heroDescription: "Connect with 5000+ successful freelancers. Get certified training, exclusive tools, and high-commission opportunities with 100+ banking partners.",
      joinButton: "Join Free",
      earningsButton: "View Earnings Calculator",
    },
    hindi: {
      pageTitle: "फ्रीलांसर नेटवर्क",
      pageSubtitle: "भारत के सबसे बड़े वित्तीय फ्रीलांसर समुदाय से जुड़ें",
      heroTitle: "वित्तीय फ्रीलांसर के रूप में प्रति माह ₹2 लाख तक कमाएं",
      heroDescription: "5000+ सफल फ्रीलांसर्स से जुड़ें। 100+ बैंकिंग पार्टनर्स के साथ प्रमाणित प्रशिक्षण, विशेष उपकरण और उच्च-कमीशन के अवसर प्राप्त करें।",
      joinButton: "मुफ्त में जुड़ें",
      earningsButton: "कमाई कैलकुलेटर देखें",
    },
    gujarati: {
      pageTitle: "ફ્રીલાન્સર નેટવર્ક",
      pageSubtitle: "ભારતના સૌથી મોટા નાણાકીય ફ્રીલાન્સર સમુદાયમાં જોડાઓ",
      heroTitle: "નાણાકીય ફ્રીલાન્સર તરીકે પ્રતિ મહિને ₹2 લાખ સુધી કમાઓ",
      heroDescription: "5000+ સફળ ફ્રીલાન્સર્સ સાથે જોડાઓ. 100+ બેન્કિંગ પાર્ટનર્સ સાથે પ્રમાણિત તાલીમ, વિશિષ્ટ સાધનો અને ઉચ્ચ-કમિશન તકો મેળવો.",
      joinButton: "મફતમાં જોડાઓ",
      earningsButton: "કમાણી કેલ્ક્યુલેટર જુઓ",
    }
  };

  const t = translations[currentLanguage];

  return (
    <>
      {/* Hero Section */}
      <section className="freelancer-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-center-content">
              <h1 className="hero-title">Get more done faster. Hire pre-vetted freelancers.</h1>
            </div>
            <div className="hero-description">
              <p className="hero-description-text">
                Connect with 5000+ successful freelancers. Get certified training, exclusive tools, 
                and high-commission opportunities with 100+ banking partners.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Talent Section */}
      <section className="talent-section">
        <div className="container">
          <div className="talent-grid">
            {/* Left Column - Text */}
            <div className="talent-content">
              <h2 className="talent-title">Access To The Top 1% Of Online Talent</h2>
              <p className="talent-description">
                We recruit, interview, and vet thousands of freelancers each week for their skills, 
                communication, and attitude. We only let in the top 1% of applicants, so you get 
                access to the best of the best from the start!
              </p>
            </div>
            
            {/* Right Column - Image */}
            <div className="talent-image">
              <img 
                src="/images/free1.png" 
                alt="Top 1% Talent" 
                className="section-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Hiring Section */}
      <section className="hiring-section">
        <div className="container">
          <div className="hiring-grid">
            {/* Left Column - Image */}
            <div className="hiring-image">
              <img 
                src="/images/free2.png" 
                alt="Fast Hiring Process" 
                className="section-image"
              />
            </div>
            
            {/* Right Column - Text */}
            <div className="hiring-content">
              <h2 className="hiring-title">Hire Within Days, Not Weeks or Months</h2>
              <p className="hiring-description">
                We'll pair you with a qualified candidate based on your job description within 
                24 hours, so you can get to work faster than ever before.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="support-section">
        <div className="container">
          <div className="support-grid">
            {/* Left Column - Text */}
            <div className="support-content">
              <h2 className="support-title">Concierge-Level Support & Service</h2>
              <p className="support-description">
                Need help figuring out who to hire next? Or the best way to execute your project? 
                Speak to one of our account managers and we'll guide you every step of the way!
              </p>
            </div>
            
            {/* Right Column - Image */}
            <div className="support-image">
              <img 
                src="/images/free3.png" 
                alt="Concierge Support" 
                className="section-image"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Freelancer;